module.exports = __webpack_public_path__ + "img/Frame 352241.dadb3d16.png";